import { default as format } from 'date-fns/format';
import { BASE_MEDIA_URL } from '@/config/config';
import moment from 'moment/moment';

export const dateFilter = (date: number | string | Date | null) => {
  date = date ? date : new Date();
  return format(new Date(date), 'yyyy-MM-dd');
};
export const dateFilter2 = (
  date: number | string | Date | null | undefined
) => {
  if (date) {
    const _date = moment(date).toDate();
    return format(
      new Date(
        Date.UTC(
          _date.getFullYear(),
          _date.getMonth(),
          _date.getDate(),
          _date.getHours(),
          _date.getMinutes(),
          _date.getSeconds()
        )
      ),
      'dd-MMMM-yyyy'
    );
  }
  return '';
};

export const logFilter = (log: any) => {
  if (log instanceof Object) {
    return JSON.stringify(log);
  }
  return `${log}`;
};

export const mediaUrl = (relativePath: string): string => {
  if (relativePath) {
    if (
      relativePath.match(
        '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$'
      )
    ) {
      return relativePath;
    }
    return BASE_MEDIA_URL + relativePath;
  }
  return 'https://photo2.tinhte.vn/data/attachment-files/2020/10/5188534_cover_iPhone_12_mini_tinhte.jpg';
};
